module.exports = __webpack_public_path__ + "img/i85.a39a03b9.png";